import Vue from "vue";
import Vuex from "vuex";
import Cart from "./cart";
import AccountResource from "./resources/account-resource";
import OrderResource from "./resources/order-resource";

import getSettings from "./support/get-settings";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentCategory: null,
    currentCategoryA: null,
    categories: [],
    products: [],
    cart: null,
    account: null,
    order: null,
    sessionId: null,
  },
  getters: {
    getAccount: (state) => {
      return state.account;
    },

    getOrder: (state) => {
      return state.order;
    },
    getProducts: (state) => {
      return state.products;
    },
    getCategories: (state) => {
      return state.categories;
    },

    getCurrentCategory: (state) => {
      return state.currentCategory;
    },
    getCurrentCategoryA: (state) => {
      return state.currentCategoryA;
    },

    getCart: (state) => {
      return state.cart;
    },

    // getProductsInCurrentCategory: (state) => {
    //   if (!state.currentCategory) return [];

    //   const category = state.currentCategory;
    //   let products = [];
    //   console.log("aqui", state);
    //   if (category.type === "S") {
    //     // Verifica se há uma subcategoria selecionada
    //     if (state.currentCategoryA) {
    //       products = state.products.filter((product) => {
    //         const productCategory = product.category;

    //         return productCategory.id === state.currentCategoryA.id;
    //       });
    //     } else {
    //       // Sem subcategoria, exibe todos os produtos da categoria principal
    //       products = state.products.filter((product) => {
    //         const productCategory = product.category;
    //         return productCategory.parent_id === category.id;
    //       });
    //     }
    //   } else if (category.type === "A") {
    //     products = state.products.filter((product) => {
    //       const productCategory = product.category;
    //       return productCategory.id === category.id;
    //     });
    //   }

    //   return state.cart ? state.cart.mapProductQuantity(products) : products;
    // },
    getProductsInCurrentCategory: (state) => {
      if (!state.currentCategory) return [];

      const category = state.currentCategory;
      let products = [];

      console.log("aqui", state);

      if (category.type === "S") {
        // Verifica se há uma subcategoria selecionada
        if (state.currentCategoryA) {
          products = state.products.filter((product) => {
            const productCategories = Array.isArray(product.category)
              ? product.category
              : [product.category];
            return productCategories.some(
              (productCategory) =>
                productCategory.id === state.currentCategoryA.id
            );
          });
        } else {
          // Sem subcategoria, exibe todos os produtos da categoria principal
          products = state.products.filter((product) => {
            const productCategories = Array.isArray(product.category)
              ? product.category
              : [product.category];
            return productCategories.some(
              (productCategory) => productCategory.parent_id === category.id
            );
          });
        }
      } else if (category.type === "A") {
        products = state.products.filter((product) => {
          const productCategories = Array.isArray(product.category)
            ? product.category
            : [product.category];
          return productCategories.some(
            (productCategory) => productCategory.id === category.id
          );
        });
      }

      return state.cart ? state.cart.mapProductQuantity(products) : products;
    },
    getMostConsumed: (state) => {
      if (state.currentCategory === null || state.cart === null) {
        return null;
      }

      const products = state.products.filter(
        (product) => product.is_most_consumed
      );

      const cart = state.cart;

      return cart.mapProductQuantity(products);
    },
  },

  actions: {
    async finishOrder(context, cardUuid) {
      const cart = this.getters.getCart;
      const settings = getSettings();

      const items = cart.items.map((item) => {
        return {
          id: item.id,
          quantity: item.quantity,
          price: parseFloat(item.price),
        };
      });

      const body = {
        totem_id: settings.totem_id,
        amount: cart.amount,
        products: items,
        session_id: context.state.sessionId,
      };

      try {
        const order = await OrderResource.finishOrder(cardUuid, body);
        context.commit("SET_ORDER", order);
      } catch (e) {
        if (e.response.status !== 202) {
          throw e;
        }
      }
    },

    cancelOrder(context) {
      context.commit("SET_ACCOUNT", null);
      context.commit("SET_CART", null);
      context.commit("SET_PRODUCTS", []);
      context.commit("SET_CATEGORIES", []);
      context.commit("SET_CURRENT_CATEGORY", null);
      context.commit("SET_ORDER", null);
    },

    async cardRead(context, cardUuid) {
      const response = await AccountResource.fetchByCardUuid(cardUuid);
      const data = response.data;
      console.log("data", data);
      const account = data.account;
      const products = data.products;
      const categories = data.categories;

      const cart = new Cart(data.account);
      const sessionId = `${Date.now()}-${getSettings().totem_id}`;

      context.commit("SET_ACCOUNT", account);
      context.commit("SET_CART", cart);
      context.commit("SET_PRODUCTS", products);
      context.commit("SET_CATEGORIES", categories);
      context.commit("SET_CURRENT_CATEGORY", categories[0]);
      context.commit("SET_SESSION_ID", sessionId);
    },
    changeCurrentCategoryS(context, category) {
      context.commit("SET_CURRENT_CATEGORY", category);
    },
    async changeCurrentCategory({ commit }, context, category) {
      context.commit("SET_CURRENT_CATEGORY", category);
      commit("SET_CURRENT_CATEGORY_A", null);
    },
    changeCurrentCategoryA({ commit }, subcategory) {
      commit("SET_CURRENT_CATEGORY_A", subcategory);
    },
    addProductToCart(context, product) {
      const cart = this.getters.getCart;
      cart.addProduct(product);

      context.commit("SET_CART", cart);
      context.commit(
        "SET_PRODUCTS",
        cart.mapProductQuantity(context.state.products)
      );
    },

    getProductQuantity(context, product) {
      const cart = this.getters.getCart;
      return cart.getProductQuantity(product);
    },

    removeFromCart(context, product) {
      const cart = this.getters.getCart;
      cart.removeProduct(product);

      context.commit("SET_CART", cart);
      context.commit(
        "SET_PRODUCTS",
        cart.mapProductQuantity(context.state.products)
      );
    },
  },
  mutations: {
    SET_CURRENT_CATEGORY(state, category) {
      state.currentCategory = category;
    },

    SET_CURRENT_CATEGORY_A(state, subcategory) {
      console.log("subcategory", subcategory);
      console.log("state", state);
      state.currentCategoryA = subcategory;
    },

    SET_PRODUCTS(state, products) {
      state.products = products;
    },

    SET_ACCOUNT(state, account) {
      state.account = account;
    },

    SET_SESSION_ID(state, sessionId) {
      state.sessionId = sessionId;
    },

    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },

    SET_LOCK_READ(state, status) {
      state.lockRead = status;
    },

    SET_CART(state, cart) {
      state.cart = cart;
    },

    SET_ORDER(state, order) {
      state.order = order;
    },
  },
});
